const LOGIN_EVENT_INITIALISING = 'fp-login-initialising'
const LOGIN_EVENT_INITIALISED = 'fp-login-initialised'
const LOGIN_EVENT_LOGIN = 'fp-login'
const LOGIN_EVENT_LOGOUT = 'fp-logout'
const LOGIN_EVENT_SUBMIT = 'fp-submit'

export enum LoginEvents {
    Initialising = LOGIN_EVENT_INITIALISING,
    Initialised = LOGIN_EVENT_INITIALISED,
    Login = LOGIN_EVENT_LOGIN,
    Logout = LOGIN_EVENT_LOGOUT,
    Submit = LOGIN_EVENT_SUBMIT
}

export type FPInitialising = CustomEvent<Record<PropertyKey, never>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [LoginEvents.Initialising]: FPInitialising;
    }
}

export type FPInitialised = CustomEvent<Record<PropertyKey, string | null | boolean | undefined>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [LoginEvents.Initialised]: FPInitialised;
    }
}

export type FPLogin = CustomEvent<Record<PropertyKey, string | null | boolean | undefined>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [LoginEvents.Login]: FPLogin;
    }
}

export type FPLogout = CustomEvent<Record<PropertyKey, string | null | boolean | undefined>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [LoginEvents.Logout]: FPLogout;
    }
}

export type FPSubmit = CustomEvent<Record<PropertyKey, string | null | boolean | undefined | object>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [LoginEvents.Submit]: FPSubmit;
    }
}